import { useTranslations } from 'next-intl'

import { PropertyType as PropertyTypeEnum, RoomIconName } from '@/entities/room'

type PropertyType = {
  title: string
  value: PropertyTypeEnum
  icon: RoomIconName
}

export const usePropertyTypes = () => {
  const t = useTranslations('common')

  const PROPERTY_TYPES: PropertyType[] = [
    {
      title: t('property_type.officetel'),
      value: PropertyTypeEnum.OFFICETEL,
      icon: 'officetel',
    },
    {
      title: t('property_type.apartment'),
      value: PropertyTypeEnum.APARTMENT,
      icon: 'apartment',
    },
    {
      title: t('property_type.low_rise_apt'),
      value: PropertyTypeEnum.VILLA,
      icon: 'villa',
    },
    {
      title: t('property_type.detached_house'),
      value: PropertyTypeEnum.DETACHED,
      icon: 'detached',
    },
    {
      title: t('property_type.studio_building'),
      value: PropertyTypeEnum.STUDIO,
      icon: 'studio',
    },
    {
      title: t('property_type.mixed_use'),
      value: PropertyTypeEnum.MIXED_USE,
      icon: 'mixedUse',
    },
    {
      title: t('property_type.goshiwon'),
      value: PropertyTypeEnum.GOSIWON,
      icon: 'gosiwon',
    },
    {
      title: t('property_type.hotel'),
      value: PropertyTypeEnum.HOTEL,
      icon: 'hotel',
    },
    {
      title: t('property_type.share_house'),
      value: PropertyTypeEnum.SHARE_HOUSE,
      icon: 'shareHouse',
    },
    {
      title: t('property_type.vacation_rental'),
      value: PropertyTypeEnum.VACATION_HOME,
      icon: 'vacationHome',
    },
    {
      title: t('property_type.guest_house'),
      value: PropertyTypeEnum.GUEST_HOUSE,
      icon: 'guestHouse',
    },
    {
      title: t('property_type.motel_inn'),
      value: PropertyTypeEnum.MOTEL,
      icon: 'motel',
    },
  ]

  return { PROPERTY_TYPES }
}
